// import MockAuthService from './mock-auth-service';
import * as MSAL from '@azure/msal-browser';
import TeamsAuthService from './teams-auth-service';
import {IAuthService} from './types';

export default class AuthService implements IAuthService {
  private authService: IAuthService;
  public clientId: string = process.env.APP_ID;

  constructor(private msalConfig: MSAL.Configuration, private usePopup = false) {
    this.initAuthService();
  }

  get config() {
    return this.authService.config;
  }

  handleLoginRedirect() {
    return this.authService.handleLoginRedirect();
  }

  login() {
    return this.authService.login();
  }

  logout() {
    return this.authService.logout();
  }

  getToken(scopes: string[]) {
    return this.authService.getToken(scopes);
  }

  async getUser() {
    return this.authService.getUser();
  }

  private initAuthService() {
    // AuthService is only ever constructed from the teams-flavored build's handleLogin()
    // (AuthProvider.desktop.tsx), so this always being TeamsAuthService is intentional: opened
    // outside Teams, getAuthToken() has no host to respond to and handleLogin() just logs the
    // rejection and stops. A MsalAuthService fallback here used to spin up a second, independent
    // PublicClientApplication and immediately loginRedirect() when opened outside Teams' iframe -
    // nothing else needs that fallback, so it was removed rather than fixed in place.
    this.authService = new TeamsAuthService();
  }
}
